module.exports = __webpack_public_path__ + "img/anli01.e464e978.png";